var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
var CircleError = function (_a) {
    var color = _a.color, props = __rest(_a, ["color"]);
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", width: "26", height: "26", viewBox: "0 0 20 21" }, props),
        React.createElement("path", { fill: color, d: "M10 .25c1.38 0 2.679.26 3.896.781A10.035 10.035 0 0 1 17.08 3.17a10.035 10.035 0 0 1 2.139 3.184A9.801 9.801 0 0 1 20 10.25c0 1.38-.26 2.679-.781 3.896a10.035 10.035 0 0 1-2.139 3.184 10.035 10.035 0 0 1-3.184 2.139A9.801 9.801 0 0 1 10 20.25c-1.38 0-2.679-.26-3.896-.781A10.035 10.035 0 0 1 2.92 17.33a10.035 10.035 0 0 1-2.14-3.184A9.801 9.801 0 0 1 0 10.25c0-1.38.26-2.679.781-3.896A10.035 10.035 0 0 1 2.92 3.17a10.035 10.035 0 0 1 3.184-2.14A9.801 9.801 0 0 1 10 .25zm0 18.77a8.44 8.44 0 0 0 3.408-.694 8.83 8.83 0 0 0 2.774-1.885 9.035 9.035 0 0 0 1.875-2.783 8.44 8.44 0 0 0 .693-3.408 8.44 8.44 0 0 0-.693-3.408 8.914 8.914 0 0 0-1.875-2.774 8.914 8.914 0 0 0-2.774-1.875A8.44 8.44 0 0 0 10 1.5a8.44 8.44 0 0 0-3.408.693 8.914 8.914 0 0 0-2.774 1.875 8.914 8.914 0 0 0-1.875 2.774 8.44 8.44 0 0 0-.693 3.408c0 1.21.231 2.347.693 3.408a9.035 9.035 0 0 0 1.875 2.783 8.83 8.83 0 0 0 2.774 1.885A8.44 8.44 0 0 0 10 19.02zm3.535-12.305a.596.596 0 0 1 .176.44.596.596 0 0 1-.176.439L10.88 10.25l2.656 2.656a.596.596 0 0 1 .176.44.596.596 0 0 1-.176.44.596.596 0 0 1-.44.175.596.596 0 0 1-.439-.176L10 11.13l-2.656 2.656a.596.596 0 0 1-.44.176.596.596 0 0 1-.44-.176.596.596 0 0 1-.175-.44c0-.175.059-.322.176-.439L9.12 10.25 6.465 7.594a.596.596 0 0 1-.176-.44.6.6 0 0 1 .176-.44.596.596 0 0 1 .44-.175c.175 0 .322.059.439.176L10 9.37l2.656-2.656a.596.596 0 0 1 .44-.176.6.6 0 0 1 .44.176z" })));
};
CircleError.defaultProps = {
    color: '#fff',
};
export default CircleError;
//# sourceMappingURL=CircleError.js.map